// extracted by mini-css-extract-plugin
export var attachment = "_mq-a";
export var emailContainer = "_mq-4";
export var emailContentPaddedContainer = "_mq-b";
export var emailHeader = "_mq-6";
export var emailIframe = "_mq-3";
export var emailInfoIcon = "_mq-9";
export var emailShortenedSummary = "_mq-e";
export var infoDropdown = "_mq-0";
export var infoRowBoundedContent = "_mq-d";
export var internal = "_mq-5";
export var merchant = "_mq-8";
export var messageInputContainer = "_mq-h";
export var normal = "_mq-7";
export var replyCard = "_mq-f";
export var subtleButton = "_mq-1";
export var subtleButtonIconContainer = "_mq-2";
export var toggleViewRepliesButton = "_mq-c";
export var wrappingText = "_mq-g";